export default __webpack_public_path__ + "static/media/noise.2793ebd0.png";